import { render, staticRenderFns } from "./ContactContent.vue?vue&type=template&id=d99dedee&scoped=true"
import script from "./ContactContent.vue?vue&type=script&lang=ts"
export * from "./ContactContent.vue?vue&type=script&lang=ts"
import style0 from "./ContactContent.vue?vue&type=style&index=0&id=d99dedee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99dedee",
  null
  
)

export default component.exports